import React from 'react';
import Loader from 'src/components/loader';
import { PageContent } from 'src/components/page';
import { useMatchedRoute } from 'src/hooks/use-matched-route';
import type { PrismicArticle } from 'src/types';
import Article from './components/article';
import { useEditorialContentPageQuery } from './queries/use-editorial-conent-page-query';

const editorialContentTypes = [
  'EDITORIAL_CONTENT',
  'CHANGELOG',
  'INFO_PAGE',
  'TEST_TYPE',
];

const EditorialContentPage = () => {
  const route = useMatchedRoute();
  const pageQuery = useEditorialContentPageQuery(route?.variables);

  if (pageQuery.isLoading) {
    return (
      <PageContent>
        <Loader />
      </PageContent>
    );
  }

  if (!pageQuery.isSuccess || !pageQuery.data.prismicArticle) {
    return null;
  }

  const dataFromArticle = pageQuery.data.prismicArticle as PrismicArticle;

  if (!dataFromArticle) return null;

  if (!editorialContentTypes.includes(dataFromArticle.type)) return null;

  return <Article {...dataFromArticle} />;
};

export default EditorialContentPage;
